import { axiosInstance } from '@/plugins/axios'
import { parseAdsRegistration } from '@/components/appDriver/adsRegistration/types'
import type { AdsRegistration } from '@/components/appDriver/adsRegistration/types'

const ENDPOINT = '/webapp/driver/ads-registration'
const REQUEST_TIMEOUT = 20000

export async function getAdsRegistration(signal?: AbortSignal): Promise<AdsRegistration> {
  const { data } = await axiosInstance.get(ENDPOINT, { signal, timeout: REQUEST_TIMEOUT })
  return parseAdsRegistration(data)
}

export async function registerAdsInterest(): Promise<AdsRegistration> {
  const { data } = await axiosInstance.post(ENDPOINT, undefined, { timeout: REQUEST_TIMEOUT })
  const registration = parseAdsRegistration(data)

  if (!registration.registered) {
    throw new Error('Ads registration was not confirmed')
  }

  return registration
}
